export const UPCOMING_ALLOWED_STATUSES = new Set([
  "paymentcompleted",
  "requested",
  "picked",
  "pending",
]);

export const UPCOMING_EXCLUDED_STATUSES = new Set(["created", "completed"]);

const getOrderDate = (order = {}) =>
  order.inStockDate ||
  order.deliveryDate ||
  order.expectedDeliveryDate ||
  order.checkInDate ||
  null;

const getStartOfToday = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
};

export const isUpcomingOrder = (order = {}) => {
  const status = (order?.status || "").toLowerCase();

  if (!status) return false;
  if (UPCOMING_EXCLUDED_STATUSES.has(status)) return false;
  if (!UPCOMING_ALLOWED_STATUSES.has(status)) return false;

  const orderDateValue = getOrderDate(order);
  if (!orderDateValue) return false;

  const orderDate = new Date(orderDateValue);
  if (Number.isNaN(orderDate.getTime())) return false;

  return orderDate >= getStartOfToday();
};

